<div class="row viewers" [ngClass]="{'row-cols-2': showImageViewer}">
   <article-component-canvas [inputData]="this.canvasInputData" class="threed"></article-component-canvas>
</div>
